import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

export const LegalPage = ({ testId, title, intro, sections }) => {
  const { t } = useTranslation();
  return (
    <div data-testid={testId} className="bg-white">
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-16 sm:py-24">
        <Link to="/" data-testid={`${testId}-back-link`} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-800 hover:gap-3 transition-all">
          <ArrowLeft size={14} /> {t("legalPages.back")}
        </Link>
        <h1 className="mt-8 font-display font-black text-4xl sm:text-5xl text-slate-900 tracking-tighter">{title}</h1>
        <div className="mt-3 text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("legalPages.updated")}</div>
        <p className="mt-8 text-base text-slate-700 leading-relaxed">{intro}</p>
        <div className="mt-10 space-y-10">
          {sections.map(([heading, body]) => (
            <section key={heading}>
              <h2 className="font-display font-bold text-lg text-slate-900">{heading}</h2>
              <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};
